module.exports = __webpack_public_path__ + "static/assets/5b9cda4a0241e4447c71913b88000924.png";